module.exports = __webpack_public_path__ + "img/fully_enclosed_and_attached_to_main_house_with_connected_roof_system.d9a78430.jpg";